<div #selectLanguage class="selectLanguage">
  <ul>
    <ng-container *ngFor="let lang of langs">
      <li *ngIf="lang != 'raw' || isAdmin()" (click)="setLang(lang)"
        [class.selected-lang]="translate.currentLang == lang"><a>{{lang}}</a>
      </li>
    </ng-container>
  </ul>
</div>